import React from 'react';
import { Grid } from '@material-ui/core';
import FilterSelector from './components/FilterSelector';

function InvoiceLogsFilters({ group, handleSetFilters, filters, report }) {
    return (
        <Grid container>
            <Grid item md={4}>
                <FilterSelector
                    group={group}
                    handleFilterChange={handleSetFilters}
                    label={group}
                    filters={filters}
                    report={report}
                />
            </Grid>
        </Grid>
    );
}

export default InvoiceLogsFilters;
